import Phaser from 'phaser';

export interface PointerDragHandlers {
  onPointerDown: (pointer: Phaser.Input.Pointer) => void;
  onPointerMove: (pointer: Phaser.Input.Pointer) => void;
  onPointerUp: (pointer: Phaser.Input.Pointer) => void;
}

export type PointerDragTeardown = () => void;

export function registerPointerDragHandlers(
  scene: Phaser.Scene,
  handlers: PointerDragHandlers
): PointerDragTeardown {
  scene.input.on('pointerdown', handlers.onPointerDown);
  scene.input.on('pointermove', handlers.onPointerMove);
  scene.input.on('pointerup', handlers.onPointerUp);
  scene.input.on('pointerupoutside', handlers.onPointerUp);

  return () => {
    scene.input.off('pointerdown', handlers.onPointerDown);
    scene.input.off('pointermove', handlers.onPointerMove);
    scene.input.off('pointerup', handlers.onPointerUp);
    scene.input.off('pointerupoutside', handlers.onPointerUp);
  };
}
